module.exports = __webpack_public_path__ + "static/media/Poppins-Bold.afb453b6.woff2";